var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewVisibleYoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H27.5V20C27.5 24.1421 24.1421 27.5 20 27.5H0.5V8Z",
    fill: "#FFFFFF",
    stroke: "#d49830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.813 13.5788C22.0192 13.8314 22.1333 14.1597 22.1333 14.5C22.1333 14.8404 22.0192 15.1686 21.813 15.4213C20.5075 16.975 17.5357 20 14.0667 20C10.5976 20 7.62591 16.975 6.32035 15.4213C6.11414 15.1686 6 14.8404 6 14.5C6 14.1597 6.11414 13.8314 6.32035 13.5788C7.62591 12.025 10.5976 9 14.0667 9C17.5357 9 20.5075 12.025 21.813 13.5788Z",
    stroke: "#d49830",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2612 17.8002C15.6788 17.8002 16.8279 16.3227 16.8279 14.5002C16.8279 12.6777 15.6788 11.2002 14.2612 11.2002C12.8437 11.2002 11.6946 12.6777 11.6946 14.5002C11.6946 16.3227 12.8437 17.8002 14.2612 17.8002Z",
    stroke: "#d49830",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewVisibleYoli);
export default __webpack_public_path__ + "static/media/view_visible_Yoli.ca0d045677c7e4ee12ccc7d739f7377e.svg";
export { ForwardRef as ReactComponent };